import styled from 'styled-components'
import { StyledGlobalMainContainer } from '../globalStyle'

export const StyledContainer = styled(StyledGlobalMainContainer)`
	margin: 141px auto 0;
	@media (max-width: 960px) {
		margin-top: 60px;
	}
`
export const StyledTitleContainer = styled.div`
	display: grid;
	justify-items: center;
	@media (max-width: 768px) {
		padding: 0;
	}
`

export const StyledMainContainer = styled.div`
	display: grid;
	grid-template-columns: 1.2fr 1fr;
	grid-column-gap: 27px;
	margin-top: 89px;
`

export const StyledMobileContainer = styled.div`
	display: grid;
	grid-auto-flow: row;
	grid-template-rows: max-content;
	grid-row-gap: 34px;
	margin-top: 49px;
`

export const StyledLeftContainer = styled.div`
	display: grid;
	@media (max-width: 768px) {
		grid-auto-flow: column;
		overflow: scroll;
		::-webkit-scrollbar {
			display: none;
		}
	}
`

export const StyledRightContainer = styled.div`
	position: relative;
	max-width: 596px;
	height: 616px;
	svg {
		width: 100%;
		position: absolute;
		box-shadow: 0px 10px 34px 8px rgba(191, 196, 202, 0.25);
	}
	@media (max-width: 768px) {
		height: 570px;
		width: 100%;
	}
`

export const StyledImageContainer = styled.div`
	width: 895px;
	height: 676px;
	position: relative;
	img {
		width: 100%;
		height: 100%;
		position: absolute;
	}
`

export const StyledUl = styled.ul`
	border-right: 1px solid #bfc4ca;
	display: grid;
	grid-auto-flow: row;
	grid-row-gap: 27px;
	grid-auto-rows: max-content;
	grid-row-gap: 15px;
	height: max-content;
	@media (max-width: 1200px) {
		grid-row-gap: 20px;
	}
`

export const StyledLi = styled.li`
	display: grid;
	grid-auto-flow: row;
	grid-row-gap: 15px;
	position: relative;
	padding: 10px 0;
	padding-right: 45px;
	padding-left: 45px;
	cursor: pointer;
	transition: all ease 1s;
	${({ active }) =>
		active &&
		`
  background: #F6F9FC;
  border-radius: 5px 0px 0px 5px;
  `}
	@media (max-width: 1200px) {
		grid-row-gap: 10px;
	}
`

export const StyledLine = styled.i`
	border-left: 4px solid #0068ff;
	position: absolute;
	right: -2px;
	height: 100%;
`

export const StyledListTitleContainer = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	align-items: center;
	grid-column-gap: 19px;
`

export const StyledIconContainer = styled.div``

export const StyledInnerGroupContainer = styled.div``
